import React from "react";
import {
  CheckboxController,
  TimeController,
  TimeControllerProps,
} from "@pushpress/shared-components";
import { FieldPath, useWatch } from "react-hook-form";
import styles from "./CheckTime.module.scss";

export interface CheckTimeProps<
  TFieldValues,
  TName extends FieldPath<TFieldValues>,
> extends TimeControllerProps<TFieldValues, TName> {
  checkboxWidth: string;
  checkboxName: TName;
  onToggle?: (checked: boolean) => void;
}

function CheckTime<TFieldValues, TName extends FieldPath<TFieldValues>>(
  props: CheckTimeProps<TFieldValues, TName>,
) {
  const {
    control,
    label,
    name,
    checkboxWidth,
    checkboxName,
    error,
    onToggle,
    ...other
  } = props;

  const checked = useWatch({
    control,
    name: checkboxName,
  });

  return (
    <div className={styles.root}>
      <div className={styles.check} style={{ width: checkboxWidth }}>
        <CheckboxController
          control={control}
          name={checkboxName}
          label={label}
          error={error}
          onToggle={onToggle}
        />
      </div>
      {checked && (
        <div className={styles.time}>
          <TimeController
            {...other}
            control={control}
            label={`${label} time`}
            name={name}
            hideLabel
            error={error}
          />
        </div>
      )}
    </div>
  );
}

export default CheckTime;
